import Constants from '../definitions/constants';
import { intl } from '../locales/localesConfig';
import JavascriptUtilsTooling from '../tooling/javascriptUtilsTooling';
import LocaleTooling from './localeTooling';
import toastr from 'toastr';
import $ from 'jquery';

const popupIds = {
  formPopup: "formPopup",
  formulaEditorPopup: "formulaEditorPopup",
  closeFormulaConfirmPopup: "closeFormulaConfirmPopup",
  closeFormConfirmPopup: "closeFormConfirmPopup"
}

const InterfaceTooling = {
  getOnKeyEnterHandler: (action) => {
    return (event) => {
      if (event.keyCode == 10 || event.keyCode == 13) {
        action(event);
      }
    };
  },
  getOnKeyEnterOrEscHandler: (actionEnter, actionEsc) => {    
    return (event) => {
      if ((event.keyCode == 10 || event.keyCode == 13) && actionEnter) {
        actionEnter(event);
      }
      else if (event.keyCode == 27 && actionEsc) {
        actionEsc(event);
      }
    };
  },
  executeActionOnScrollBottom: (event, action) => {
    const scroll = event.target.scrollTop;
    const max = event.target.scrollHeight - event.target.offsetHeight;
    if (scroll >= max-1) {
      action();
    }
  },
  delayCallAction: (action, timeoutObjectToReplace, time = Constants.interface.delayCallActionTime) => {
    if(timeoutObjectToReplace!=null) {
      clearTimeout(timeoutObjectToReplace);      
    }
    return setTimeout(function(){
      action();
    }, time);
  },
  popupShow: (popupId, setStateFunction) => {
    var popupObjectStep1 = {};
    popupObjectStep1[popupId] = { render:true, show: false }
    setStateFunction(popupObjectStep1);
    setTimeout(function(){
      var popupObjectStep2 = {};
      popupObjectStep2[popupId] = { render:true, show: true }
      setStateFunction(popupObjectStep2);
    }, 1);
  },
  popupHide: (popupId, setStateFunction) => {
    var popupObjectStep1 = {};
    popupObjectStep1[popupId] = { render:true, show: false }
    setStateFunction(popupObjectStep1);
    setTimeout(function(){
      var popupObjectStep2 = {};
      popupObjectStep2[popupId] = { render:false, show: false }
      setStateFunction(popupObjectStep2);
    }, Constants.interface.popup.transitionTime);
  },
  popupHasToRender: popupState => {
    return popupState ? popupState.render : false;
  },
  handleShowFormPopupWithConfirmOnExit: (event, popupId, state, setState, loading = false, callbackOnOpen = null, popupIdConfirmClose="closeFormConfirmPopup") => {
    if(event) {
      event.preventDefault();
    };    
    if(loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(state[popupId])) {
      if(callbackOnOpen) {
        callbackOnOpen();
      }
      InterfaceTooling.popupShow(popupId, setState);
    }
    else {
      if((popupId == "formPopup") && (state.formHasChanges!=null) && state.formHasChanges){        
        InterfaceTooling.handleShowPopup(event, popupIdConfirmClose, state, setState, loading);
      }
      else{
        InterfaceTooling.popupHide(popupId, setState);
      }
    }
  },
  handleShowPopup: (event, popupId, state, setState, loading = false, callbackOnOpen = null) => {
    if(event) {
      event.preventDefault();
    };    
    if(loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(state[popupId])) {
      if(callbackOnOpen) {
        callbackOnOpen();
      }
      InterfaceTooling.popupShow(popupId, setState);
    }
    else {
      InterfaceTooling.popupHide(popupId, setState);
    }
  },
  apiCallResultFeedback: (arrayPrevStatus, arrayStatus, messageSuccess, messageError = null, succesCallbacksArray = null) => {
    let showSuccess = false;
    let showError = false;

    for(var i=0; i<arrayStatus.length; i++) {
      if (arrayPrevStatus[i] == null && arrayStatus[i] != null) {
        showSuccess = arrayStatus[i]==200;
        showError = arrayStatus[i]!=200;
        break;
      }
    }

    if(showSuccess) {
      if(messageSuccess) {
        toastr.options = Constants.interface.tostrOptions;
        toastr.success(messageSuccess,"");
      }
      if(succesCallbacksArray) {
        succesCallbacksArray.forEach((callback) => { callback(); });
      }
    }
    else if(showError && messageError) {
      toastr.options = Constants.interface.tostrOptions;
      toastr.error(messageError,""); 
    }    
  },
  getSelectArray: (constantsPath, translatePath, emptyValue = true, emptyText = "") => {
    var selectArray = [];
    var keys = JavascriptUtilsTooling.getObjectStringPathKeyValue(Constants,constantsPath);
    if(emptyValue) {
      selectArray.push({ 
        value: "",
        label: emptyText
      });      
    }
    Object.keys(keys).forEach(function(key,index) {
        var selectValue = keys[key];
        selectArray.push({ 
          value: selectValue,
          label: LocaleTooling.getCalculationUnitContextLocale(intl.formatMessage({ id: translatePath + "." + selectValue }))
        });            
    });
    return selectArray;
  },
  getSelectArrayFromArrayOfObjects: (arrayOfOBjects, valueAccesor, labelAccesor, emptyValue = true, emptyText = "") => {
    var selectArray = [];
    if(emptyValue) {
      selectArray.push({ 
        value: "",
        label: emptyText
      });      
    }
    if(arrayOfOBjects) {
      arrayOfOBjects.forEach(function(item) {
          selectArray.push({ 
            value: item[valueAccesor],
            label: item[labelAccesor],
          });            
      });
    }
    return selectArray;
  },
  getSelectArrayFromArray: (array, emptyValue = true, emptyText = "") => {
    var selectArray = [];
    if(emptyValue) {
      selectArray.push({ 
        value: "",
        label: emptyText
      });      
    }
    if(array) {
      array.forEach(function(item) {
          selectArray.push({ 
            value: item,
            label: item,
          });            
      });
    }
    return selectArray;
  },
  bringObjectEditorInputIntoView: () => {
    let itemTop = null;
    let itemBottom = null;
    let scrollTo = null;
    let add = $(".free-text-list-overlay .free-text-list-list-item-add");
    let edit = $(".free-text-list-overlay .free-text-list-list-item-edit");
    let scrollWrap = $(".free-text-list-overlay .free-text-list-list-wrapper")[0];
    if(add.length>0) {       
      itemTop = add[0].getBoundingClientRect().top;
      itemBottom = add[0].getBoundingClientRect().bottom+3;
    }
    if(edit.length>0) {
      itemTop = edit[0].getBoundingClientRect().top;
      itemBottom = edit[0].getBoundingClientRect().bottom;
    }
    if(itemBottom!=null && itemBottom>scrollWrap.getBoundingClientRect().bottom) {
      scrollTo = scrollWrap.scrollTop+(itemBottom-scrollWrap.getBoundingClientRect().bottom);
    }
    else if(itemTop!=null && itemTop<scrollWrap.getBoundingClientRect().top) {
      scrollTo = scrollWrap.scrollTop-(scrollWrap.getBoundingClientRect().top-itemTop);
    }
    if(scrollTo!=null) {
      $(".free-text-list-overlay .free-text-list-list-wrapper").animate({
          scrollTop: scrollTo
      }, 100);
    }
  },
  handleShowClosePopup: (event, popupId, popupIdConfirmClose, state, setState, loading = false, callbackOnOpen = null) => {
    if(event) {
      event.preventDefault()
    };    
    if(loading) {
      return;
    } 
    if(!InterfaceTooling.popupHasToRender(state[popupId])) {
      if(callbackOnOpen) {
        callbackOnOpen();
      }
      InterfaceTooling.popupShow(popupId, setState);
    }
    else {
      //pending logic for when there are no changes in the formula editor
      if(popupId == "formPopup"){
        if(Object.keys(state.pendingSaveFields).length == 0){
          InterfaceTooling.popupHide(popupId, setState);
        }
        else{
          InterfaceTooling.handleShowPopup(event, popupIdConfirmClose, state, setState, loading);
        }
      }
      if(popupId == "formulaEditorPopup"){
        //InterfaceTooling.handleShowPopup(event, popupIdClose, state, setState, loading);
        InterfaceTooling.popupHide(popupId, setState);
      }
    }
  },
  handleCloseFormulaConfirmPopup: async(containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.closeFormulaConfirmPopup, containerObject.state, 
      containerObject.setState.bind(containerObject)
    );
  },
  handleCloseFormConfirmPopup: async(containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.closeFormConfirmPopup, containerObject.state, 
      containerObject.setState.bind(containerObject)
    );
  },
  handleCloseForm: async(containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.closeFormConfirmPopup, containerObject.state, 
      containerObject.setState.bind(containerObject)
    );
    InterfaceTooling.handleShowPopup(
      event, popupIds.formPopup, containerObject.state, 
      containerObject.setState.bind(containerObject)
    );
    containerObject.setState({
      formHasChanges: false,
    })
  },
  handleCloseFormula: async(containerObject, event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.closeFormulaConfirmPopup, containerObject.state, 
      containerObject.setState.bind(containerObject)
    );
    InterfaceTooling.handleShowPopup(
      event, popupIds.formulaEditorPopup, containerObject.state, 
      containerObject.setState.bind(containerObject)
    );      
    containerObject.setState({ formulaHasChanges: false })
  },
  getCloseFormConfirmPopupState: (containerObject) => {
    return containerObject.state[popupIds.closeFormConfirmPopup];
  },
  getCloseFormulaConfirmPopupState: (containerObject) => {
    return containerObject.state[popupIds.closeFormulaConfirmPopup];
  }
};

export default InterfaceTooling;


// WEBPACK FOOTER //
// ./source/tooling/interfaceTooling.js